import React, { useMemo } from 'react';
import FilterBar from '../Common/FilterBar';
import { useOnlineSchoolFees } from '../../DataStore/OnlineSchoolFeesContext';

const OnlineFeesFilterBar = ({filter}) => {
    const {dispatch, openingDate, closingDate, status, searchText} = useOnlineSchoolFees();

      // build options once
    const statusOptions = useMemo(
      () => [
        { value: "all", label: "All" },
        { value: "1", label: "Cleared" },
        { value: "0", label: "Uncleared" },
      ],
      []
    );

    const handleFilter = () => {
        filter();
    };

    return (
    <FilterBar
      title="Transaction Listing"
      subtitle="Filter online fees payments."
        //   iconClass="fa fa-receipt"
      controls={[
        {
          type: "search",
          value: searchText,
          placeholder: "Search...",
          onChange: (e) => dispatch({ type: "searchText", payload: e.target.value }),
          onEnter: filter,
          width: 240,
        },
        {
          type: "dateRange",
          fromValue: openingDate,
          toValue: closingDate,
          onChangeFrom: (e) =>dispatch({ type: 'openingDate', payload: e.target.value }),
          onChangeTo: (e) => dispatch({ type: 'closingDate', payload: e.target.value }),
        },
        {
            type: "select",
            value: status,
            options: statusOptions,
            width: 170,
            onChange: (e) => dispatch({ type: 'status', payload: e.target.value }),
            }
      ]}
      actions={[
        { label: "Apply", iconClass: "fa fa-filter", onClick: handleFilter, variant: "primary" },
      ]}
    />
    );
};

export default OnlineFeesFilterBar;